module.exports = __webpack_public_path__ + "img/icon-footer-ig-dark.6b834545.svg";